export default __webpack_public_path__ + "alberta-swodoc.0a8e764fedf3d5f9c848.svg";